import React from "react";
import PropTypes from "prop-types";

import styles from "./VisualitzacioTitol.module.css";

const VisualitzacioTitol = ({ children }) => {
  return <div className={styles.Titol}>{children}</div>;
};

VisualitzacioTitol.propTypes = {
  children: PropTypes.node.isRequired
};
export default VisualitzacioTitol;
